import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    onClick?.();
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(245, 158, 11, 0)', '0px 0px 25px rgba(245, 158, 11, 0.6)', '0px 0px 0px rgba(245, 158, 11, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`relative group overflow-hidden rounded-lg bg-gradient-to-r from-amber-500 to-orange-600 px-8 py-4 font-bold text-white shadow-lg transition-all ${className}`} data-id="element-207">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-208" />
      <span className="relative flex items-center justify-center gap-2 text-lg md:text-xl uppercase tracking-wide" data-id="element-209">
        <Zap className="w-6 h-6 fill-current" data-id="element-210" />
        {children}
      </span>
    </motion.button>;
}